"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconList = exports.iconnameToCSSName = exports.iconnameToFonticon = exports.iconnameToReadableName = exports.classnameToIconname = exports.fonticonToIconname = exports.classnameToReadableName = exports.fonticonToReadableName = void 0;
var IconFunctions = __importStar(require("./icons"));
/**
 * Convert an icon font classname to a readable name
 * e.g "hc-icon--control-share-ios" -> "control share ios"
 */
exports.fonticonToReadableName = function (classname) {
    var iconname = classname;
    iconname = iconname.replace(/^hc-icon--/, '');
    iconname = iconname.replace(/-/g, ' ');
    iconname = iconname.toLowerCase();
    return iconname;
};
/**
 * For backwards compatibility
 *
 * @param classname
 */
exports.classnameToReadableName = function (classname) {
    // tslint:disable no-console
    console.warn('"classnameToReadableName" has been deprecated. Please use "fonticonToReadableName" instead.');
    // tslint:enable no-console
    return exports.fonticonToReadableName(classname);
};
/**
 * Convert an icon font classname to the Honeycomb icon name
 * e.g "hc-icon--control-accordion-close" -> "controlAccordionClose"
 *
 * Note this is only approximate as it can't reverse groups of capitals, i.e
 * "control-share-ios" converts to "controlShareIos" instead of "controlShareIOS"
 *
 * @param classname
 */
exports.fonticonToIconname = function (classname) {
    var iconname = classname;
    iconname = iconname.replace(/^hc-icon--/, '');
    iconname = iconname
        .split('-')
        .map(function (item, i) {
        if (i === 0) {
            return item;
        }
        return item.substr(0, 1).toUpperCase() + item.substr(1);
    })
        .join('');
    return iconname;
};
/**
 * For backwards compatibility
 *
 * @param classname
 */
exports.classnameToIconname = function (classname) {
    // tslint:disable no-console
    console.warn('"classnameToIconname" has been deprecated. Please use "fonticonToIconname" instead.');
    // tslint:enable no-console
    return exports.fonticonToIconname(classname);
};
/**
 * Convert a Honeycomb Icon name to a readable name
 * e.g "iconControlShareIOS" -> "control share ios"
 */
exports.iconnameToReadableName = function (iconname) {
    return iconname
        .split('')
        .reduce(function (acc, chr, index) {
        if (index === 0) {
            // Return the first character
            return chr;
        }
        var result = '';
        if ((iconname[index - 1] + chr).match(/[a-z][A-Z0-9]/)) {
            // When a lowercase character is followed by an uppercase character or number, insert a space between them
            // e.g the "eA" and "t3" matches in "messageAlert32" result in "message Alert 32"
            result = acc + " " + chr;
        }
        else if ((iconname[index - 1] + chr).match(/[A-Z][0-9]/)) {
            // When an uppercase character is followed by a number, insert a space between them
            // e.g the "A3" match in "logoCBA32" results in "logo CBA 32"
            result = acc + " " + chr;
        }
        else if (iconname.length >= 2 && (iconname[index - 2] + iconname[index - 1] + chr).match(/[A-Z]{2}[a-z]/)) {
            // When two uppercase characters are followed by a lowercase character, insert a space before the last uppercase
            // e.g the "ASy" match in "logoCBASymbol" results in "logo CBA Symbol"
            result = acc.slice(0, -1) + " " + acc.slice(-1) + chr;
        }
        else {
            result = acc + chr;
        }
        return result;
    }, '')
        .replace(/^(icon\s)/, '')
        .toLowerCase();
};
/**
 * Convert the Honeycomb Icon name to a CSS classname for the icon font
 * e.g iconControlShareIOS -> hc-icon--control-share-ios
 * @param iconname
 */
exports.iconnameToFonticon = function (iconname) {
    var classname = iconname.replace(/\d*$/, '');
    classname = exports.iconnameToReadableName(classname);
    classname = classname.replace(/\s/g, '-');
    classname = "hc-icon--" + classname;
    return classname;
};
/**
 * Convert the icon name to the CSS name
 * e.g "controlAccordionClose24" to "iconControlAccordionClose24"
 * @param iconname
 */
exports.iconnameToCSSName = function (iconname) {
    var cleanIconname = iconname.replace(/^icon/, '');
    var classname = 'icon';
    classname += cleanIconname.charAt(0).toUpperCase();
    classname += cleanIconname.slice(1);
    return classname;
};
// tslint:enable typedef-whitespace
exports.IconList = {};
// Create a list of icons using the functions that were generated from the SVG files
Object.keys(IconFunctions)
    .sort()
    .forEach(function (iconName) {
    var css = 'icon' + iconName.charAt(0).toUpperCase() + iconName.slice(1);
    exports.IconList[iconName] = {
        css: css,
        name: exports.iconnameToReadableName(iconName),
        svgfile: iconName + ".svg",
        // @ts-ignore
        svginline: IconFunctions[iconName],
        // @ts-ignore
        svginlineArgs: IconFunctions[iconName + "Args"],
    };
});
//
// The iconfont is only here for backwards compatibility, it's not updated anymore.
//
[
    'hc-icon--badge',
    'hc-icon--badge-alert',
    'hc-icon--badge-info',
    'hc-icon--badge-new',
    'hc-icon--badge-offer',
    'hc-icon--control-accordion-close',
    'hc-icon--control-accordion-open',
    'hc-icon--control-bills',
    'hc-icon--control-bills-past',
    'hc-icon--control-calendar',
    'hc-icon--control-chevron-forward',
    'hc-icon--control-close',
    'hc-icon--control-contact',
    'hc-icon--control-delete',
    'hc-icon--control-edit',
    'hc-icon--control-email',
    'hc-icon--control-feedback',
    'hc-icon--control-file-download',
    'hc-icon--control-file-upload',
    'hc-icon--control-help',
    'hc-icon--control-item-add',
    'hc-icon--control-item-remove',
    'hc-icon--control-keyboard',
    'hc-icon--control-link-out',
    'hc-icon--control-location',
    'hc-icon--control-log-off',
    'hc-icon--control-log-on',
    'hc-icon--control-manage',
    'hc-icon--control-more',
    'hc-icon--control-page-down',
    'hc-icon--control-page-up',
    'hc-icon--control-pin',
    'hc-icon--control-print',
    'hc-icon--control-recurring',
    'hc-icon--control-refresh',
    'hc-icon--control-reminder',
    'hc-icon--control-search',
    'hc-icon--control-search-filter',
    'hc-icon--control-settings',
    'hc-icon--control-share-android',
    'hc-icon--control-share-ios',
    'hc-icon--control-tools',
    'hc-icon--player-sound-on',
    'hc-icon--player-sound-off',
    'hc-icon--player-back',
    'hc-icon--player-forward',
    'hc-icon--player-full-screen-enter',
    'hc-icon--player-full-screen-exit',
    'hc-icon--player-pause',
    'hc-icon--player-play',
    'hc-icon--player-stop',
    'hc-icon--spend-category-business',
    'hc-icon--spend-category-cash',
    'hc-icon--spend-category-donation',
    'hc-icon--spend-category-eating-out',
    'hc-icon--spend-category-education',
    'hc-icon--spend-category-entertainment',
    'hc-icon--spend-category-fees-and-interest',
    'hc-icon--spend-category-groceries',
    'hc-icon--spend-category-health',
    'hc-icon--spend-category-home',
    'hc-icon--spend-category-income',
    'hc-icon--spend-category-money-transfer',
    'hc-icon--spend-category-shopping',
    'hc-icon--spend-category-tax-paid',
    'hc-icon--spend-category-transportation',
    'hc-icon--spend-category-travel',
    'hc-icon--spend-category-uncategorised',
    'hc-icon--spend-category-utilities',
    'hc-icon--tick',
].forEach(function (classname) {
    // Converts 'hc-icon--control-accordion-close' to 'controlAccordionClose'
    var searchName = exports.fonticonToIconname(classname);
    // Searches for any size variant of the icon, i.e 'controlAccordionClose32', 'controlAccordionClose64', and all are updated
    var existingIcons = Object.keys(exports.IconList).filter(function (iconName) {
        var regex = new RegExp("^" + searchName, 'i');
        return regex.test(iconName);
    });
    if (existingIcons.length === 0) {
        // Icon exists in the iconfont but not in the SVG directory, so a new entry is created
        /* istanbul ignore next */
        exports.IconList[searchName] = {
            iconfont: classname,
            name: exports.fonticonToReadableName(classname),
        };
    }
    else {
        // Icon exists in both iconfont and SVG directory, so the existing entry is ammended
        existingIcons.forEach(function (iconName) {
            exports.IconList[iconName].iconfont = classname;
        });
    }
});
